module.exports = __webpack_public_path__ + "media/tishi.6d8d8f22.mp3";